<!--
 * @FileDescription: 
 * @Author: jianguo Wang
 * @Date: 2023-12-14 15:29:31
 * @LastEditors: jianguo Wang
 * @LastEditTime: 2025-01-10 14:18:02
-->
<template>
  <div class="page-contain">
    <!--
    <div class="step-contain">
      <div class="step-box">
        <div class="step step01">01</div>
        <div class="step-title">{{ $t('components.secondPart.561361-0') }}</div>
        <div class="step-tip">{{ $t('components.secondPart.561361-1') }}</div>
      </div>
      <div class="step-box">
        <div class="step step02">02</div>
        <div class="step-title">{{ $t('components.secondPart.561361-2') }}</div>
        <div class="step-tip">{{ $t('components.secondPart.561361-3') }}</div>
      </div>
      <div class="step-box">
        <div class="step step03">03</div>
        <div class="step-title">{{ $t('components.secondPart.561361-4') }}</div>
        <div class="step-tip">{{ $t('components.secondPart.561361-5') }}</div>
      </div>
    </div>
    -->

    <!-- pc -->
    <div class="pc-contain">
      <div class="contain">
        <div class="tip-contain">
          <div class="lekang-intro">
            湖南养康堂健康科技有限公司，是一家以大健康产业为基础，通过AI人工智能技术，赋能传统大健康理疗行业，为大健康行业的中小门店实现数字化转型的一家科技型公司。
          </div>
          <div class="lekang-intro">
            公司研发的乐康到家APP，能有效地将全国各地的中医诊所，中医馆的医生，以及理疗养生行业的技师，链接到一起，并通过乐康到家大健康商城，连接供应链，融合AI，打通大健康实体与互联网相结合的一个全新生态平台。
          </div>
        </div>
        <img src="@/assets/lekang2.jpg" alt="" />
      </div>
      <!--
      <div class="contain">
        <img src="@/assets/02@3x-en.png" alt="" />
        <div class="tip-contain">
          <div class="tip1">{{ $t('components.secondPart.561361-9') }}</div>
          <div class="tip2">{{ $t('components.secondPart.561361-10') }}</div>
        </div>
      </div>
      <div class="contain">
        <div class="tip-contain">
          <div class="tip1">{{ $t('components.secondPart.561361-11') }}</div>
          <div class="tip2">
            {{ $t('components.secondPart.561361-12') }}
          </div>
        </div>
        <img src="@/assets/03@3x-en.png" alt="" />
      </div>
      <div class="contain">
        <img src="@/assets/04@3x-en.png" alt="" />
        <div class="tip-contain">
          <div class="tip1">{{ $t('components.secondPart.561361-13') }}</div>
          <div class="tip2">
            {{ $t('components.secondPart.561361-14') }}
            {{ $t('components.secondPart.561361-15') }}
          </div>
        </div>
      </div>
      -->
    </div>

    <!-- 移动端 -->
    <div class="phone-contain">
      <div class="contain">
        <div class="tip-contain">
          <div class="lekang-intro">
            湖南养康堂健康科技有限公司，是一家以大健康产业为基础，通过AI人工智能技术，赋能传统大健康理疗行业，为大健康行业的中小门店实现数字化转型的一家科技型公司。
          </div>
          <div class="lekang-intro">
            公司研发的乐康到家APP，能有效地将全国各地的中医诊所，中医馆的医生，以及理疗养生行业的技师，链接到一起，并通过乐康到家大健康商城，连接供应链，融合AI，打通大健康实体与互联网相结合的一个全新生态平台。
          </div>
        </div>
        <img src="@/assets/lekang2.jpg" alt="" />
      </div>
      <!--
      <div class="contain">
        <div class="tip-contain">
          <div class="tip1">{{ $t('components.secondPart.561361-9') }}</div>
          <div class="tip2">{{ $t('components.secondPart.561361-10') }}</div>
        </div>
        <img src="@/assets/02@3x-en.png" alt="" />
      </div>
      <div class="contain">
        <div class="tip-contain">
          <div class="tip1">{{ $t('components.secondPart.561361-11') }}</div>
          <div class="tip2">
            {{ $t('components.secondPart.561361-12') }}
          </div>
        </div>
        <img src="@/assets/03@3x-en.png" alt="" />
      </div>
      <div class="contain">
        <div class="tip-contain">
          <div class="tip1">{{ $t('components.secondPart.561361-13') }}</div>
          <div class="tip2">
            {{ $t('components.secondPart.561361-14') }}
          </div>
        </div>
        <img src="@/assets/04@3x-en.png" alt="" />
      </div>
      -->
    </div>
  </div>
</template>

<script>
export default {
  name: "secondPart",
  _scopeId: "data-v-4637cfce",
  props: {
    msg: String,
  },
};
</script>

